const $flexMenuItem = $('.menu-item.flexibility');
const $affiMenuItem = $('.menu-item.affidability');
const $innoMenuItem = $('.menu-item.innovation');

const $flexContent = $('.flexibility-content');
const $affiContent = $('.affidability-content');
const $innoContent = $('.innovation-content');

const $eggFaiSection = $('.egg-fai');

const showFlexContent = () => {
  $flexContent.show()
  $flexMenuItem.children('.selected').show()
  $flexMenuItem.children('.unselected').hide()
  $eggFaiSection.addClass('dancer')
}

const hideFlexContent = () => {
  $flexContent.hide()
  $flexMenuItem.children('.selected').hide()
  $flexMenuItem.children('.unselected').show()
  $eggFaiSection.removeClass('dancer')
}

const showAffiContent = () => {
  $affiContent.show()
  $affiMenuItem.children('.selected').show()
  $affiMenuItem.children('.unselected').hide()
  $eggFaiSection.addClass('mom')
}

const hideAffiContent = () => {
  $affiContent.hide()
  $affiMenuItem.children('.selected').hide()
  $affiMenuItem.children('.unselected').show()
  $eggFaiSection.removeClass('mom')
}

const showInnoContent = () => {
  $innoContent.show()
  $innoMenuItem.children('.selected').show()
  $innoMenuItem.children('.unselected').hide()
  $eggFaiSection.addClass('shuttle')
}

const hideInnoContent = () => {
  $innoContent.hide()
  $innoMenuItem.children('.selected').hide()
  $innoMenuItem.children('.unselected').show()
  $eggFaiSection.removeClass('shuttle')
}

jQuery(() => {
  // Setup iniziale
  $affiContent.hide();
  $innoContent.hide();

  $flexMenuItem.click(() => {
    showFlexContent()
    hideAffiContent()
    hideInnoContent()
  })
  $affiMenuItem.click(() => {
    hideFlexContent()
    showAffiContent()
    hideInnoContent()
  })
  $innoMenuItem.click(() => {
    hideFlexContent()
    hideAffiContent()
    showInnoContent()
  })
})



// WEBPACK FOOTER //
// ./src/js/fai.js